import { DialogHost, FieldNavHost, ToastHost } from '@orgazone/ui-web';

/**
 * Hôtes UI partagés du back-office (§24.1quater) — montés UNE fois près de la racine.
 *
 * Sans cet hôte, `confirm()` répond NON par sécurité et `alert()` n'écrit qu'en console : les actions
 * à confirmation deviennent muettes. C'est la raison d'être de ce fichier, pas une formalité de montage.
 * ⚠️ Le back-office parle la charte : les dialogues prennent la palette et les icônes PAR DÉFAUT du paquet.
 */
export function BackofficeUiHost() {
  return (
    <>
      <ToastHost />
      <FieldNavHost />
      <DialogHost />
    </>
  );
}
